module.exports={
  "id": "grab-and-go",
  "name": "Grab and go",
  "badge": "Small crowd favorite",
  "subtext": "Perfect for lunch, these complete boxed meals make easy work of keeping a group well-fed.",
  "coverImage": "https://img.peerspace.com/image/upload/v1725383524/fs6jg8u0103totenmx02.jpg",
  "price": {
    "value": 29.0,
    "per_person": true
  },
  "menu": {
    "menu_sections": [
      {
        "id": "grab-and-go-includes",
        "title": "Includes",
        "description": "Convenient boxed lunch which comes with a sandwich, water bottle, and a sweet treat."
      },
      {
        "id": "grab-and-go-selections",
        "title": "Sandwiches (select up to 3)",
        "min_selections": 1,
        "max_selections": 3,
        "items": [
          {
            "name": "Ham and swiss",
            "price": {
              "value": 0.0
            }
          },
          {
            "name": "Turkey and cheese",
            "price": {
              "value": 0.0
            }
          },
          {
            "name": "Caprese",
            "price": {
              "value": 0.0
            }
          },
          {
            "name": "Vegetable",
            "price": {
              "value": 0.0
            }
          }
        ]
      }
    ]
  },
  "description": "Convenient boxed lunch which comes with a sandwich, water bottle, and a sweet treat."
}